import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';
import DataContext from '../../data/DataContext';
// import MsgRetry from '../../../asset/img/btn_refresh_nor.png';
// import MsgRetryPressed from '../../../asset/img/btn_refresh_pre.png';
import MsgDelete from '../../../asset/img/btn_remove_nor.svg';
// import MsgDeletePressed from '../../../asset/img/btn_remove_pre.png';
import ChatbotIco from '../../../asset/img/ico_msg_chatbot.png';
import moment from 'moment';

const styles = (theme) => ({
  root: {
    display: 'flex',
    // letterSpacing: "-0.5px",
    // whiteSpace: "pre-wrap",
    // zIndex: 10,
    // outline: 0
  },
  leftContainer: {
    justifyContent: 'flex-start',
    marginBottom: '2px',
  },
  rightContainer: {
    justifyContent: 'flex-end',
    marginTop: '24px',
    alignItem: 'center',
  },
  message: {
    fontSize: theme.font.size15, // "15px",
    borderRadius: '12px',
    // flexWrap: "wrap",
    color: theme.color.message.color,
    padding: '9px 20px',
    maxWidth: '75%',
    // zIndex: 10,
    // wordWrap: 'break-word',
    // wordBreak: "break-word"
  },
  chatbotImage: {
    width: '32px',
    height: '32px',
    backgroundImage: `url(${ChatbotIco})`,
    margin: '0 6px 0 16px',
  },
  date: {
    color: theme.color.message.date,
    fontSize: theme.font.size10,
    // fontWeight: "300",
    alignSelf: 'center',
    margin: '5px 0 0 0',
    // textAlign: "center"
  },
  rightDate: {
    margin: '0 16px 0 0',
  },
  deleteBox: {
    // position: "relative"
    marginRight: '4px',
  },
  btnDelete: {
    // position: "absolute",
    // left: "-25px",
    // top: "12px",
    width: '12px',
    height: '12px',
    zIndex: '20',
    cursor: 'pointer',
    border: 'none',
    // outline: "0 none",
    backgroundColor: 'transparent',
    backgroundSize: '12px',
    backgroundImage: `url(${MsgDelete})`,
    backgroundRepeat: 'no-repeat',
    // "&:active": {
    //   backgroundImage: `url(${MsgDeletePressed})`,
    // }
  },
});

function DateLeftRaw(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  return (
    <div
      className={[classes.root, classes.leftContainer].join(' ')}
      role={'text'}
      aria-label={`${context.string.aria.chatbotMessage}, ${moment(
        data.date,
        'LT'
      ).format('A hh시 mm분')}`}
      tabIndex={0}
    >
      <div className={classes.chatbotImage}></div>
      <p
        className={classes.date}
        aria-label={`${moment(data.date, 'LT').format('A hh시 mm분')}`}
      >
        {data.date}
      </p>
    </div>
  );
}

function DateRightRaw(props) {
  const { classes, data } = props;
  const context = useContext(DataContext);
  const online = data.online;

  const handleDelete = () => {
    let deleteMsgs = [data.id];
    if (data.TXMsgId) {
      deleteMsgs.push(data.TXMsgId);
    }
    context.deleteMessage(deleteMsgs);
  };

  return (
    <div
      className={[classes.root, classes.rightContainer].join(' ')}
      role={'text'}
      tabIndex={0}
      aria-label={`${context.string.aria.myMessage} ${moment(data.date, 'LT').format(
        'A hh시 mm분'
      )}`}
    >
      {!online && (
        <div className={classes.deleteBox}>
          <button type="button" className={classes.btnDelete} onClick={handleDelete} />
        </div>
      )}
      <p
        className={[classes.date, classes.rightDate].join(' ')}
        aria-label={`${moment(data.date, 'LT').format('A hh시 mm분')}`}
      >
        {data.date}
      </p>
    </div>
  );
}
const DateRight = withStyles(styles)(DateRightRaw);
const DateLeft = withStyles(styles)(DateLeftRaw);

function DateMsg(props) {
  const { data } = props;
  return !data.hide && (data.mine ? <DateRight data={data} /> : <DateLeft data={data} />);
}
export default withStyles(styles)(DateMsg);
